module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/39_0f1ef88fefc8d193e414343b410e445a.jpg";